import React, { useEffect, useState } from 'react';
const InstallPWAButton = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isInstallable, setIsInstallable] = useState(false);
  useEffect(() => {
    // Listen for the beforeinstallprompt event
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      // Save the event to trigger the install prompt later
      setDeferredPrompt(e);
      setIsInstallable(true);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();  // Show the install prompt
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the install prompt');
        } else {
          console.log('User dismissed the install prompt');
        }
        setDeferredPrompt(null);  // Clear the saved prompt
      });
    }
  };

  return (
    <>
      {isInstallable && (
        <button 
          className="w-full  bg-orange-400  text-white p-4 max-[450px]:p-2 sm:p-2 md:p-2 rounded-full shadow-lg my-2"
          onClick={handleInstallClick}
        >
          install
        </button>
      )}
    </>
  );
};

export default InstallPWAButton;
